module.exports = __webpack_public_path__ + "img/flb.56a71d3d.png";